import { Reducer } from 'redux';
import { IGenericError, IHealthDashboardState } from '../common/defaults';
import * as actionTypes from './types';
const $ = require('jquery');

// Type-safe initialState!
const initialState: IHealthDashboardState = {
  allErrors: [],
  testErrors: null
};

const reducer: Reducer<IHealthDashboardState> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_ERRORS: {
      let _state = { ...state };
      _state = { ..._state, allErrors: action.value };
      return _state;
    }
    case actionTypes.GET_TEST_ERRORS: {
      let _state = { ...state };
      _state = { ..._state, testErrors: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
